var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.31 116.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.31,58.75A34.16,34.16,0,1,1,62,24,34.16,34.16,0,0,1,95.31,58.75ZM61.18,80.2c3.16,0,6.33,0,9.5,0A12.55,12.55,0,0,0,83.24,67.52q0-9.37,0-18.74A12.57,12.57,0,0,0,70.48,36H51.74A12.57,12.57,0,0,0,39.08,48.69q0,9.44,0,18.86A12.55,12.55,0,0,0,51.61,80.19C54.8,80.22,58,80.2,61.18,80.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.87,58.05c0-3.1,0-6.2,0-9.3a8.77,8.77,0,0,1,8.92-8.92H70.53a8.77,8.77,0,0,1,8.92,8.93q0,9.39,0,18.8a8.76,8.76,0,0,1-8.86,8.85q-9.44,0-18.87,0a8.76,8.76,0,0,1-8.85-8.86C42.86,64.38,42.87,61.22,42.87,58.05Zm7,0A11.31,11.31,0,1,0,61.16,46.81,11.33,11.33,0,0,0,49.85,58ZM72.93,43.46a2.71,2.71,0,1,0,2.73,2.67A2.68,2.68,0,0,0,72.93,43.46Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.1,65.64a7.52,7.52,0,1,1,7.58-7.43A7.53,7.53,0,0,1,61.1,65.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/INSTAGRAM.3144522cd7c5f9ff8be53068afcdf76a.svg";
export { ForwardRef as ReactComponent };